import * as React from "react";

import "./ad-budget-route.scss";

import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {keyed}           from "@Common/react/keyed";
import {Load}            from "@Common/react/load";
import {formatMoney}     from "@Common/ui-components/language/format-money";
import {parseDate}       from "@Common/utils/date-object";
import {parseDateFormat} from "@Common/utils/date/parse-date-format";
import {isEmpty, values} from "@Common/utils/objects";

import {WalletLayout} from "../common/wallet-layout";

import {DetailsModal} from "./details-modal/details-modal";

export const AccountAdBudgetRoute = ({}) => cs(
    ({}, next) => WalletLayout({activeTab: "ad-budget", next}),

    consumeContext("apis"),
    ["adBudgets", ({apis}, next) => Load({
        fetch: () => apis.next.adBudgets.getAdBudgetHistory(),
        next,
    })],
    ["detailsModal", (_, next) => DetailsModal({next})],
    ({detailsModal, adBudgets}) => (
        <div className="adBudgets-route-52k">

            {!adBudgets ? (
                <div className="no-data" xd-qa-type="label" xd-qa-name="Loading">
                    Loading...
                </div>
            ) : isEmpty(adBudgets) ? (
                <div className="no-data" xd-qa-type="label" xd-qa-name="Empty">
                    No AdBudgets available
                </div>
            ) : (
                values(adBudgets).map((adBudget) => cs(
                    keyed(adBudget.idPrimary),
                    () => (
                        <div className="card" xd-qa-type="card" xd-qa-name={adBudget.accountName}>
                            <div className="line1">
                                <div className="left">

                                    <div className="label" xd-qa-type="label" xd-qa-name="Ad Budget">
                                        Ad Budget
                                    </div>
                                    <div className="title" title={`${adBudget.accountName}`} xd-qa-type="text" xd-qa-name={adBudget.accountName}>
                                        {adBudget.accountName}
                                    </div>

                                    <div className="actions">
                                        <a onClick={() => detailsModal.show(adBudget)} xd-qa-type="link" xd-qa-name="Details">
                                            Details
                                        </a>
                                    </div>
                                </div>

                                <div className="right" xd-qa-type="text" xd-qa-name="Amount">
                                    {formatMoney(adBudget.balanceAmount, {useFreeLabel: false})}
                                </div>
                            </div>

                            <div className="details-train">
                                <div className="car">
                                    <div className="label" xd-qa-type="label" xd-qa-name="Order Usage History">
                                        Order Usage History
                                    </div>
                                    <div className="value" xd-qa-type="text" xd-qa-name="Usage Amount">
                                        {adBudget.orders?.length ?? 0} Times
                                    </div>
                                </div>
                                <div className="car">
                                    <div className="label" xd-qa-type="label" xd-qa-name="Balance Updated on">
                                        Balance Updated on
                                    </div>
                                    <div className="value" xd-qa-type="text" xd-qa-name="Balance Updated Date">
                                        {parseDateFormat("MMM dd, yyyy").formatDate(parseDate(adBudget.datemodified))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                ))
            )}
        </div>
    ),
);
